import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the element referenced by the URL hash whenever the route/hash
// changes, and scrolls to the top of the page for plain route changes.
export function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location]);

  return null;
}

export default ScrollToHash;
